import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationError, provideRouter, TitleStrategy, withNavigationErrorHandler } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { jwtInterceptor } from './core/auth/jwt.interceptor';
import { authErrorInterceptor } from './core/auth/auth-error.interceptor';
import { researchInterceptor } from './core/research/research.interceptor';
import { isChunkLoadError, reloadForNewBuild } from './core/errors/chunk-load-error';
import { CustomTitleStrategy } from './core/services/title-strategy.service';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      // A deploy can delete the chunk a still-open tab is about to lazy-load.
      // Reload once so the user lands on the current build instead of a blank page.
      withNavigationErrorHandler((error: NavigationError) => {
        if (isChunkLoadError(error.error)) reloadForNewBuild(error.url);
      }),
    ),
    // researchInterceptor must run before authErrorInterceptor: it attaches
    // X-Research-Id so scoped endpoints (experiments, datasets, preprocessing)
    // filter by active research server-side.
    provideHttpClient(withInterceptors([jwtInterceptor, researchInterceptor, authErrorInterceptor])),
    provideAnimations(),
    Title,
    { provide: TitleStrategy, useClass: CustomTitleStrategy },
  ]
};
